<template>
  <terms-form :edit="edit" @added="backToList" @updated="backToList" @cancel="backToList" />
</template>
<script>
import TermsForm from '@/components/forms/TermsForm';

// @vuese
// Formularz do edycji ustawień
// @group Setting
export default {
  components: {
    TermsForm
  },
  props: {
    // Czy edycja
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // @vuese
    // Powrót do listy ustawień
    backToList() {
      this.$router.push({ name: 'termsList' });
    }
  }
};
</script>